import { mapEntityProperties } from '@/utils/mapEntityProperties'
import type { Pagination1OfServiceAdminDto } from '@/backend/market'
import { ServiceResponseEntity } from '../../domain/entities/ServiceResponseEntity'
import { ServiceMiniModel } from './ServiceMiniModel'

export class ServiceResponseModel extends ServiceResponseEntity {
  constructor(dataDto: Pagination1OfServiceAdminDto) {
    const serviceMiniModels = dataDto.items?.map((item) => new ServiceMiniModel(item ))
    super()
    mapEntityProperties<ServiceResponseEntity>(this, dataDto, {
      map: {
        items: serviceMiniModels
      }
    })
  }
}
